/* eslint-disable jsx-a11y/alt-text */
// import { initial } from 'lodash';
import React from 'react';
import { Link } from 'react-router-dom';
import { Col, Row } from 'reactstrap';
import Card from 'reactstrap/lib/Card';
import Container from 'reactstrap/lib/Container';
import { ames247Axios } from 'configs/api';
import { default as Loading } from 'components/Error/Loading';

const BookListComponent = () => {
  const [state, setState] = React.useState({
    data: [],
    loading: true,
  });

  React.useEffect(() => {
    let check = true;

    ames247Axios.get(`/api/GetAllCourse`).then((res) => {
      if (check) {
        const data = res.data;
        setState((...pre) => ({ ...pre, data: data.result, loading: false }));
      }
    });
    return () => (check = false);
  }, []);

  // componentDidMount() {
  //   const res = fetch('').then((res)=>res.json())
  //   this.setState({data:res})
  // }

  const renderItem = () => {
    return state.data.map((item, index) => {
      return (
        <Col lg={3} md={4} sm={6} xs={12} key={index}>
          <Link to={`/lms/sach-dien-tu/book-detail/${item.id}`}>
            <div className='mb-4'>
              <img style={{ borderRadius: '0.25rem' }} width='100%' src={item.imageUrl} />
              <div style={{ minHeight: 64 }} className='pt-2'>
                <h5 className='text-center'>{item.title}</h5>
              </div>
            </div>
          </Link>
        </Col>
      );
    });
  };
  if (state.loading) return <Loading />;

  return (
    <Container fluid className='mt-4'>
      <Card className='p-4'>
        <Row>{renderItem()}</Row>
      </Card>
    </Container>
  );
};
export default BookListComponent;
